function isBrowser() {
	return typeof window !== "undefined" && typeof document !== "undefined";
}

function isIpad() {
	const ua = navigator.userAgent || navigator.vendor || window.opera;

	return (
		ua.includes("iPad") ||
		(ua.includes("Macintosh") && "ontouchend" in document) ||
		navigator.platform === "iPad" ||
		(navigator.platform === "MacIntel" && "ontouchend" in document)
	);
}

function isIOS() {
	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isIphoneProMax() {
	const { width } = window.screen;
	const { height } = window.screen;
	const dpr = window.devicePixelRatio;

	return (
		width === 440 && height === 956 && dpr === 3 // iPhone 16 Pro Max
	);
}

function isIphonePro() {
	const { width } = window.screen;
	const { height } = window.screen;
	const dpr = window.devicePixelRatio;

	return (
		width === 402 && height === 874 && dpr === 3 // iPhone 16 Pro
	);
}

const isAndroid = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	return /android/.test(userAgent);
};

function isNotSafari() {
	const userAgent = navigator.userAgent.toLowerCase();
	return !(/safari/.test(userAgent) && !/chrome/.test(userAgent)); // Exclude Chrome
  }

// eslint-disable-next-line import/prefer-default-export
export { isBrowser, isIpad, isIOS, isIphoneProMax, isIphonePro, isAndroid, isNotSafari };
